import { forwardRef } from "react";
import { Button } from "@components";
import { motion } from "motion/react";
import classNames from "classnames/bind";
import { getLinkData, replaceStringVar } from "@/core/utils";
import { GetSearchPageQuery } from "@graphqlTypes";
import ExternalArrow from "@/assets/svg/external-arrow.svg";

import styles from './Search.module.scss';
const cx = classNames.bind(styles);

type NoResultsProps = (GetSearchPageQuery['rhPage']['searchPageData']['noResults'] | GetSearchPageQuery['rhPage']['searchPageData']['noShopResults']) & {
  searchTerm: string;
}

const NoResults = forwardRef<HTMLDivElement, NoResultsProps>((props, ref) => {
  const { headline, body, cta, searchTerm } = props;
  const ctaData = getLinkData(cta);
  const headlineText = replaceStringVar(headline, { term: searchTerm });
  const ctaIcon = cta?.linkType?.[0] === 'external' ? ExternalArrow : undefined;
  
  return (
    <div className={cx("no-results")} ref={ref}>
      <div className={cx("no-results__copy")}>
        <h2 className="title-lc-s">{headlineText}</h2>
        <p className="text-m">{body}</p>
      </div>
      {ctaData && <Button {...ctaData} icon={ctaIcon} />}
    </div>
  )
});

export default motion.create(NoResults);